import React, { useEffect } from 'react';

import { Box, Button } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';

import './Header.css';

import { useAuth } from '../../auth/useAuth';
import LocalStorageService from '../../services/localStorage';

const localStorageService = LocalStorageService.getService();

const Header: React.FC<{ isQuestionnaire: boolean }> = ({
  isQuestionnaire,
}) => {
  const { isAuthenticated, logout } = useAuth();

  const [logo, setLogo] = React.useState<string | null>(null);

  const brandingInfo = localStorageService.getBrandingInfo();

  useEffect(() => {
    if (brandingInfo) {
      setLogo(JSON.parse(brandingInfo).logo ?? null);
    } else {
      setLogo(null);
    }
  }, [brandingInfo]);

  return (
    <Box component="section" className="headerBox">
      <Grid container className="container">
        {logo && (
          <Grid
            size={{ md: 3.3, sm: 6, xs: 12 }}
            style={{ borderRight: '2px solid #004E87', padding: '5px 0' }}
            className="providers-header-logo"
          >
            <img
              src={logo}
              alt="BlueCross BlueSheild"
              style={{ maxWidth: '220px' }}
            />
          </Grid>
        )}
        <Grid
          size={{ md: 8.7, sm: 6, xs: 12 }}
          className="providers-header"
          style={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            className="providers-header-text"
            style={{ paddingLeft: logo ? '32px' : '0px' }}
          >
            {isQuestionnaire ? 'Policy Questionnaire' : 'Medical Policies'}
          </div>
          {isAuthenticated && (
            <Button
              onClick={logout}
              variant="text"
              size="small"
              sx={{ color: 'white' }}
            >
              Sign Out
            </Button>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
